// src/components/layout/AppLayout.tsx

import React from 'react';
import { Sidebar } from './Sidebar';

interface Props { children: React.ReactNode; }

export const AppLayout: React.FC<Props> = ({ children }) => (
  <div className="app-layout">
    <Sidebar />
    <main className="app-main">
      {children}
    </main>
  </div>
);
